var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowsMaximize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 4.66667C17.5 4.02233 18.0223 3.5 18.6667 3.5H23.3333C23.9777 3.5 24.5 4.02233 24.5 4.66667V9.33333C24.5 9.97767 23.9777 10.5 23.3333 10.5C22.689 10.5 22.1667 9.97767 22.1667 9.33333V5.83333H18.6667C18.0223 5.83333 17.5 5.311 17.5 4.66667Z",
    fill: "#008187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1583 3.84171C24.6139 4.29732 24.6139 5.03601 24.1583 5.49162L17.1583 12.4916C16.7027 12.9472 15.964 12.9472 15.5084 12.4916C15.0528 12.036 15.0528 11.2973 15.5084 10.8417L22.5084 3.84171C22.964 3.3861 23.7027 3.3861 24.1583 3.84171Z",
    fill: "#008187"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 17.5C5.311 17.5 5.83333 18.0223 5.83333 18.6667V22.1667H9.33333C9.97767 22.1667 10.5 22.689 10.5 23.3333C10.5 23.9777 9.97767 24.5 9.33333 24.5H4.66667C4.02233 24.5 3.5 23.9777 3.5 23.3333V18.6667C3.5 18.0223 4.02233 17.5 4.66667 17.5Z",
    fill: "#008187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4916 15.5083C12.9472 15.9639 12.9472 16.7026 12.4916 17.1583L5.49162 24.1582C5.03601 24.6139 4.29732 24.6139 3.84171 24.1582C3.3861 23.7026 3.3861 22.9639 3.84171 22.5083L10.8417 15.5083C11.2973 15.0527 12.036 15.0527 12.4916 15.5083Z",
    fill: "#008187"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 17.5C23.9777 17.5 24.5 18.0223 24.5 18.6667V23.3333C24.5 23.9777 23.9777 24.5 23.3333 24.5H18.6667C18.0223 24.5 17.5 23.9777 17.5 23.3333C17.5 22.689 18.0223 22.1667 18.6667 22.1667H22.1667V18.6667C22.1667 18.0223 22.689 17.5 23.3333 17.5Z",
    fill: "#008187"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5084 15.5083C15.964 15.0527 16.7027 15.0527 17.1583 15.5083L24.1583 22.5083C24.6139 22.9639 24.6139 23.7026 24.1583 24.1582C23.7027 24.6139 22.964 24.6139 22.5084 24.1582L15.5084 17.1583C15.0528 16.7026 15.0528 15.9639 15.5084 15.5083Z",
    fill: "#008187"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4.66667C3.5 4.02233 4.02233 3.5 4.66667 3.5H9.33333C9.97767 3.5 10.5 4.02233 10.5 4.66667C10.5 5.311 9.97767 5.83333 9.33333 5.83333H5.83333V9.33333C5.83333 9.97767 5.311 10.5 4.66667 10.5C4.02233 10.5 3.5 9.97767 3.5 9.33333V4.66667Z",
    fill: "#008187"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84171 3.84171C4.29732 3.3861 5.03601 3.3861 5.49162 3.84171L12.4916 10.8417C12.9472 11.2973 12.9472 12.036 12.4916 12.4916C12.036 12.9472 11.2973 12.9472 10.8417 12.4916L3.84171 5.49162C3.3861 5.03601 3.3861 4.29732 3.84171 3.84171Z",
    fill: "#008187"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsMaximize);
export default __webpack_public_path__ + "static/media/arrows-maximize.d2adf34a63f890c8c7acbf94bf926f35.svg";
export { ForwardRef as ReactComponent };